import React, { useEffect, useContext } from 'react'

// Context
import { TitleDispatch } from 'context/title-context'

const SAS_HELP_CENTER = "SAS Help Center"

interface Props {
  title: string
}

const Title = ({title}:Props) => {
  const setTitle = useContext(TitleDispatch)

  useEffect(() => {
    document.title = `${SAS_HELP_CENTER}: ${title}`
    setTitle(title) /* eslint-disable-line */
    return function cleanup() {
      document.title = SAS_HELP_CENTER
    }
  }, [title]) /* eslint-disable-line */

  return <></>
}

export default Title